import {
    Flame,
    HeartPulse,
    Users,
    ArrowRight,
} from "lucide-react";

const gamesLink = "https://www.playtohealhub.com/landing/game";

const movementGames = [
    {
        title: "Call It Out Loud",
        description: "Anti-bullying, student voice, and safe peer intervention.",
        icon: Flame,
        color: "bg-[#ff3366]",
        image: "/assets/StM_bg.jpg",
    },
    {
        title: "Remembrance",
        description: "Grief and loss support.",
        icon: HeartPulse,
        color: "bg-[#ffbc00]",
        image: "/assets/Remembrance_bg.jpg",
    },
    {
        title: "Beyond the Game",
        description: "Athlete mental health, identity, pressure, and resilience.",
        icon: HeartPulse,
        color: "bg-[#16bdf4]",
        image: "/assets/btg_image.jpg",
    },
    {
        title: "And Far More",
        description: "Explore the full Play to Heal Hub collection of dialogue games.",
        icon: ArrowRight,
        color: "bg-[#8b5cf6]",
        image: "/assets/Hub_Background.png",
    },
];

export default function LargerMovementSection() {
    return (
        <section className="relative overflow-hidden bg-[#fff7df] px-6 py-10 lg:px-8">
            <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{
                    backgroundImage: "url('/assets/schools/problem-texture.png')",
                }}
            />

            <div className="relative mx-auto max-w-6xl">
                <div className="mb-7 text-center">
                    <div className="mx-auto mb-3 inline-flex items-center gap-2 border-[3px] border-black bg-[#16bdf4] px-4 py-2 text-xs font-black uppercase text-white shadow-[4px_4px_0_#000]">
                        <Users size={16} strokeWidth={3} />
                        Part of a Larger Movement
                    </div>

                    <h2 className="mx-auto max-w-4xl text-3xl font-black uppercase leading-none md:text-5xl">
                        One Game in a Bigger{" "}
                        <span className="mt-2 inline-block rounded-[8px] border-[3px] border-black bg-[#ff3366] px-3 py-1 text-white shadow-[4px_4px_0_#000]">
                            Healing Ecosystem
                        </span>
                    </h2>

                    <p className="mx-auto mt-4 max-w-3xl text-sm font-semibold leading-6 md:text-base">
                        Call It Out Loud is part of Trance4mation Games’ growing collection
                        of dialogue-based healing experiences — each designed to help people
                        speak honestly, listen deeply, and build stronger communities.
                    </p>
                </div>

                <div className="rounded-[24px] border-[5px] border-black bg-white p-5 shadow-[8px_8px_0_#000]">
                    <div className="mb-5 rounded-[16px] border-[3px] border-black bg-[#fff2cf] px-4 py-3 text-center">
                        <p className="text-base font-black uppercase leading-tight md:text-xl">
                            Trance4mation Games creates tools for the conversations people need most.
                        </p>
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {movementGames.map((game) => {
                            const Icon = game.icon;

                            return (
                                <a
                                    key={game.title}
                                    href={gamesLink}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="group relative block min-h-[170px] overflow-hidden rounded-[18px] border-[4px] border-black bg-[#f8f4ea] p-4 shadow-[4px_4px_0_#000] transition-transform hover:-translate-y-1 hover:shadow-[6px_6px_0_#000]"
                                >
                                    {/* Blurred/lightened image background */}
                                    <div
                                        className="absolute inset-0 scale-110 bg-cover bg-center blur-[2px] brightness-110 saturate-110 transition-transform duration-300 group-hover:scale-125"
                                        style={{
                                            backgroundImage: `url('${game.image}')`,
                                        }}
                                    />

                                    {/* Readability overlay */}
                                    {/* <div className="absolute inset-0 bg-white/35" /> */}

                                    {/* Dark gradient behind the text area */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/20 to-white/20" />

                                    <div className="relative z-10 flex h-full min-h-[138px] flex-col justify-between">
                                        <div
                                            className={`inline-flex h-10 w-10 items-center justify-center rounded-full border-[3px] border-black ${game.color} text-white shadow-[3px_3px_0_#000]`}
                                        >
                                            <Icon size={20} strokeWidth={3} />
                                        </div>

                                        {/* Text panel */}
                                        <div className="mt-4 rounded-[12px] border-[3px] border-black bg-white/85 p-3 shadow-[3px_3px_0_#000] backdrop-blur-[2px]">
                                            <h3 className="mb-1 text-base font-black uppercase leading-tight md:text-lg">
                                                {game.title}
                                            </h3>

                                            <p className="text-xs font-bold leading-5 md:text-sm">
                                                {game.description}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}